// AuthContext
export const USER_LOCAL_STORAGE_KEY = "user";

// AuthForm
export const LOGIN_USERNAME_NAME = "username";
export const LOGIN_PASSWORD_NAME = "password";

export const SUCCESS_LOGIN_STATUS_CODE = 200;

export const UPDATE_USER_NOGLITCH_LATENCY = 250; // in millisecond
export const TOAST_NOGLITCH_LATENCY = 500; // in millisecond

export const MIN_TEXT_INPUT_LIMIT = 3;
export const MAX_TEXT_INPUT_LIMIT = 20;
